import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";
import IAresService from "features/ares/services/IAresService";
import AresService from "features/ares/services/AresService";

export const aresModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<IAresService>(IocTypes.AresService).to(AresService);
});